import {
  getClass,
  getNotice,
  getUser,
  postNotice,
  putNotice,
  url,
} from "api/api";
import Loading from "components/Loading";
import { NoDataWithImageTextButton } from "components/NoDataComponent";
import {
  AttachFileWrap,
  OutlinePrimaryBtn,
  SolidPrimaryBtn,
  SolidPrimarySubBtn,
  SolidPrimaryWhiteBtn,
  SolidRedBtn,
} from "components/button/Button";
import { CustomCheckbox, SelectOption } from "components/input/Input";
import {
  ListContentWrap,
  PageArticleWrap,
  PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ClassInfo,
  NoticeInfo,
  NoticeWriteType,
  UserInfo,
  provinceInfo,
} from "type/type";
import {
  MONTHS,
  aesCBCDecrypt,
  formattedDateHyphenYYYYMMDD,
} from "utils/commonUtils";
import { CommonModalComponent } from "components/ModalComponent";
import Pagenation from "components/common/Pagenation";
import { DocIcon } from "styles/global-styles";

// 체크박스 css
const CheckBoxWrap = styled.div`
  background-color: ${({theme}) => theme.rootWhite};
  position: absolute;
  right: 0;
  top: 3rem;
  display: flex;
  flex-direction: column;
  width: calc(100% - 3rem);
  border-radius: 0.5rem;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.18);
  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    &:hover {
      background-color: ${({theme}) => theme.newTheme.default.secondary};
      cursor: pointer;
    }
  }
`;

const NoticeOne = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
`;
// 공지사항 등록/수정
const EditContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-areas:
    "a b"
    "a c";
  gap: 1rem;
  grid-template-columns: 2fr 1fr;
  overflow: hidden;
`;
const FileOneWrap = styled.div`
  width: calc((100% - 1.5rem) / 4);
  aspect-ratio: 1 / 1;
  border-radius: 0.5rem;
  border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .preview-image {
    height: 100%;
    aspect-ratio: 1 / 1;
    object-fit: contain;
  }
  .delete-preview-image {
    display: none;
    position: absolute;
    top: 1px;
    right: 1px;
  }
  &:hover {
    cursor: pointer;
    img:not(.cancel-icon),
    label {
      opacity: 0.7;
    }
    .delete-preview-image {
      display: block;
    }
  }
`;
const DocumentWrap = styled.div`
  padding: 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
`;



// --- 고정 DATA
let ListUrl = "";
let months = MONTHS;
const NODATATEXTNOTICE = [
  { index: 1, text: "아직 등록된 공지사항이 없어요." },
  { index: 2, text: "새로운 공지사항을 등록해 볼까요?" },
];
const allowedExtensions = ["pdf", "pptx", "docx", "xlsx"];
const allowedExtensionsImage = ["jpg", "jpeg", "png"];

// 공지사항 수정
export function NoticeEdit() {
  const URL = url;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  function goList() {
    navigate(ListUrl);
  }
  const { noticeIdx } = useParams();
  const { state } = useLocation();
  // 전역 데이터
  const { classData, userData } = useContext(UserClassContext);
  const [selectNoticeId, setSelectNoticeId] = useState<number>(Number(noticeIdx));
  const [selectDatas, setSelectDatas] = useState<NoticeWriteType>({
    title: "",
    content: "",
    user_id: 1,
    class_ids: [],
    remove_file_id_list: [],
  });

  // 반 영역 선택 시 checkbox show/hide
  const selectClassRef = useRef(null);
  const [isShow, setIsShow] = useState(false);
  function clickSelectClassInput() {
    setIsShow((prev) => !prev);
  }
  const [checkAll, setCheckAll] = useState(false);
  function checkedClassIds({
    currentTarget: { value, checked },
  }: React.ChangeEvent<HTMLInputElement>) {
    let allIds = classData.map((c) => c.id);
    // 전체 선택 체크/해제 시
    if (Number(value) === 0) {
      if (checked) {
        setSelectDatas((prev) => ({ ...prev, class_ids: allIds }));
        setCheckAll(true);
      } else {
        setSelectDatas((prev) => ({ ...prev, class_ids: [] }));
        setCheckAll(false);
      }
    }
    // 전체가 아닌 value를 체크/해제 할 때
    else {
      if (!checked) {
        let ids = selectDatas.class_ids.filter((cId) => Number(value) !== cId);
        setSelectDatas((prev) => ({ ...prev, class_ids: ids }));
        if (selectDatas.class_ids.length === classData.length)
          setCheckAll(false);
      }
      // 체크 시
      else {
        let ids = [...selectDatas.class_ids, Number(value)].sort(
          (a, b) => a - b
        );
        setSelectDatas((prev) => ({ ...prev, class_ids: ids }));
        if (selectDatas.class_ids.length === classData.length - 1)
          setCheckAll(true);
      }
    }
  }
  function handlerChangeData({
    currentTarget: { name, value },
  }: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
    setSelectDatas((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // 파일 관련 시작 -----------------------
  const [docList, setDocList] = useState<File[]>([]); // 문서 파일 자체
  const [imageList, setImageList] = useState<File[]>([]); // 이미지 파일 자체
  const [previewImg, setPreviewImg] = useState<String[]>([]); // 이미지 파일의 url(미리보기 이미지)
  const [docCount, setDocCount] = useState(0);
  const [imageCount, setImageCount] = useState(0);
  const FILEMAXCOUNT = 10;
  const FILEDOCMAXCOUNT = 5;
  const fileInput = useRef<HTMLInputElement>(null);
  const docInput = useRef<HTMLInputElement>(null);
  // 파일 선택 - input 클릭 시(사진)
  const handleButtonClick = (e: any) => {
    fileInput.current?.click();
  };
  // 파일 선택 - input 클릭 시(문서)
  const handleDocButtonClick = (e: any) => {
    if (docInput.current) docInput.current.click();
  };
  // 사진등록 handler
  const fileHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileArr = event.target.files;
    let _fileArr: File[] = [];

    let count = 0; // 등록된 사진 수
    if (fileArr && fileArr.length) {
      // file type 확인
      for (let j = 0; j < fileArr.length; j++) {
        if (fileArr[j].type.includes("image")) _fileArr.push(fileArr[j]);
      }
      count = _fileArr.length > FILEMAXCOUNT ? FILEMAXCOUNT : _fileArr.length;
      setImageList(_fileArr.slice(0, count));
      setImageCount(count);
      // 파일 url
      let fileUrls: string[] = [];
      _fileArr.forEach((file, index) => {
        const fileRead = new FileReader();
        fileRead.onload = (e) => {
          if (e.target && e.target.result) {
            fileUrls[index] = e.target.result.toString();
            setPreviewImg(fileUrls);
          }
        };
        fileRead.onloadend = () => {
          event.target.value = "";
        };
        fileRead.readAsDataURL(file);
      });
    }
  };
  // 미리보기 파일 전체 삭제
  function deleteAllPreviewImage() {
    setImageList([]);
  }
  // 이미지 hover 시 파일삭제(x) 버튼 클릭 - 이미지 삭제(화면상에서만)
  const handleDeleteFile = (imageIndex: number) => {
    setImageList(imageList.filter((img, index) => index !== imageIndex));
    setPreviewImg(previewImg.filter((img, index) => index !== imageIndex));
  };
  // 문서 등록
  const docHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileArr = event.target.files;
    let _fileArr: File[] = [];

    let count = 0; // 등록된 문서 수
    if (fileArr && fileArr.length) {
      // file type 확인
      for (let j = 0; j < fileArr.length; j++) {
        const fileName = fileArr[j].name;
        const fileExtension = fileName
          .substring(fileName.lastIndexOf(".") + 1)
          .toLowerCase(); // 파일 이름으로부터 확장자 추출

        if (fileExtension && allowedExtensions.includes(fileExtension))
          _fileArr.push(fileArr[j]);
      }
      count =
        _fileArr.length > FILEDOCMAXCOUNT ? FILEDOCMAXCOUNT : _fileArr.length;
      setDocList(_fileArr.slice(0, count));
      setDocCount(count);
      // 파일 url
      _fileArr.forEach((file, index) => {
        const fileRead = new FileReader();
        fileRead.onloadend = () => {
          event.target.value = "";
        };
        fileRead.readAsDataURL(file);
      });
    }
  };
  // 미리보기 파일 전체 삭제
  function deleteAllDoc() {
    setDocList([]);
  }
  // 파일 hover 시 파일삭제(x) 버튼 클릭 - 파일삭제(화면상에서만)
  const handleDeleteDoc = (docIndex: number) => {
    setDocList(docList.filter((doc, index) => index !== docIndex));
  };
  // 파일 관련 끝 -----------------------
  // 작성 완료 후 등록 시작---------------------
  async function submitNotebookInfo() {
    try {
      if (!selectNoticeId) return;
      if (!selectDatas.title) {
        alert("공지사항 제목을 입력해주세요.");
        return;
      }
      if (!selectDatas.content) {
        alert("공지사항 내용을 입력해주세요.");
        return;
      }
      // 전체 공지일 때 class_ids 빈배열로 보내야함
      if (selectDatas.class_ids.length === classData.length)
        selectDatas.class_ids = [];
      // 이미지/문서 하나로 합치기
      const fileDatas: File[] = [...imageList, ...docList];
      // 다 입력이 됐다면 API 호출
      let goList = false;
      let formData = new FormData();
      // 파일이 있는 경우 FormData로 파일 추가
      const jsonData = JSON.stringify(selectDatas);
      const _jsonData = new Blob([jsonData], { type: "application/json" });
      formData.append("data", _jsonData, "data");
      /**
       * TODO: (241002) 여기서 에러가 남, 수정 필요 (fildDatas에 object가 들어감)
       */
      if (fileDatas.length > 0) {
        fileDatas.forEach((file, index) => {
          formData.append("files", file);
        });
      } else formData.append("files", new Blob([]));
      const result = await putNotice(selectNoticeId, formData);
      goList = result.code === 200 ? true : false;
      if (result?.message) alert(result?.message);
      if (goList) navigate(`${ListUrl}`);
    } catch (error) {
      console.error("API error ", error);
    }
  }
  // 작성 완료 후 등록 끝---------------------
  // useEffect --------------------
  useEffect(() => {
    if (state.class_list.length === classData.length) setCheckAll(true);
    else setCheckAll(false);
    // 공지사항 정보
    setSelectDatas({
      title: state.title,
      content: state.content,
      user_id: state.user_id,
      class_ids: state.class_list.map((c: ClassInfo) => c.id),
      remove_file_id_list:[],
    });
    // 파일 정보
    let imageCount = 0;
    let docCount = 0;
    if (state.file_list.length) {
      let _docFileArr: File[] = [];
      let _imageFileArr: File[] = [];
      let imageUrl = [];
      const fileArr = state.file_list;

      for (let j = 0; j < fileArr.length; j++) {
        const fileExtension = fileArr[j].mime_type; // 파일 확장자
        if (fileExtension && allowedExtensions.includes(fileExtension))
          _docFileArr.push(fileArr[j]);
        else if (
          fileExtension &&
          allowedExtensionsImage.includes(fileExtension)
        ) {
          _imageFileArr.push(fileArr[j]);
          imageUrl.push(
            `${URL}/v1/sites/${state.site_id}/file?file_name=${fileArr[j].file_name}`
          );
        }
      }
      docCount =
        _docFileArr.length > FILEDOCMAXCOUNT
          ? FILEDOCMAXCOUNT
          : _docFileArr.length;
      imageCount =
        _imageFileArr.length > FILEDOCMAXCOUNT
          ? FILEDOCMAXCOUNT
          : _imageFileArr.length;
      setDocList(_docFileArr.slice(0, docCount));
      setImageList(_imageFileArr.slice(0, imageCount));
      setDocCount(docCount);
      setImageCount(imageCount);
      setPreviewImg(imageUrl); // 이미지 미리보기
    }
    setLoading(true);
  }, [state]);
  useEffect(() => {
    setImageCount(imageList.length);
  }, [imageList]);
  useEffect(() => {
    setDocCount(docList.length);
  }, [docList]);
  return (
    <>
      <PageHeaderTitleButtonStyle>
        <p className="header-title">공지사항 수정</p>
        {/* <div className="button-wrap">
                      <OutlinePrimaryBtn className="default-btn">불러오기</OutlinePrimaryBtn>
                      <OutlinePrimaryBtn className="default-btn">임시저장</OutlinePrimaryBtn>
                  </div> */}
        <div className="button-wrap">
          <SolidPrimaryWhiteBtn className="default-btn" onClick={goList}>
            취소
          </SolidPrimaryWhiteBtn>
          <SolidPrimaryBtn
            className="default-btn"
            onClick={submitNotebookInfo}
          >
            완료
          </SolidPrimaryBtn>
        </div>
      </PageHeaderTitleButtonStyle>
      <PageArticleWrap>
        {!loading ? (
          <Loading />
        ) : (
          <>
            <nav className="filter-container">
              <div className="filter-wrap position-r">
                <label>반</label>
                <input
                  type="text"
                  name="class_ids"
                  onClick={clickSelectClassInput}
                  ref={selectClassRef}
                  value={
                    checkAll
                      ? "전체"
                      : selectDatas.class_ids.length === classData.length ||
                        selectDatas.class_ids.length === 0
                      ? "전체"
                      : selectDatas.class_ids
                          .map(
                            (selectClassIdx) =>
                              classData.find((c) => selectClassIdx === c.id)
                                ?.name
                          )
                          .join(", ")
                  }
                  readOnly
                />
                {isShow && (
                  <CheckBoxWrap className="checkbox-div-wrap">
                    <label htmlFor="checkAll">
                      전체
                      <CustomCheckbox
                        type="checkbox"
                        id="checkAll"
                        name="class_ids"
                        value={0}
                        checked={checkAll}
                        onChange={checkedClassIds}
                      />
                    </label>
                    {classData.map((c) => (
                      <label key={c.id} htmlFor={`class${c.id}`}>
                        {c.name}
                        <CustomCheckbox
                          type="checkbox"
                          id={`class${c.id}`}
                          name="class_ids"
                          value={c.id}
                          checked={
                            selectDatas.class_ids.find(
                              (selectClassIdx) => c.id === selectClassIdx
                            )
                              ? true
                              : false
                          }
                          onChange={checkedClassIds}
                        />
                      </label>
                    ))}
                  </CheckBoxWrap>
                )}
              </div>
            </nav>
            <EditContainer>
              <article className="edit-content-container">
                <div className="article-header">
                  <p>
                    <span className="article-header-title">내용 작성</span>
                  </p>
                </div>
                <div className="article-content">
                  <div>
                    <label htmlFor="title"></label>
                    <input
                      type="text"
                      name="title"
                      id="title"
                      value={selectDatas.title}
                      onChange={handlerChangeData}
                      placeholder="공지사항 제목 입력"
                    />
                  </div>
                  <div>
                    <label htmlFor="content"></label>
                    <textarea
                      name="content"
                      id="content"
                      cols={30}
                      rows={10}
                      value={selectDatas.content}
                      onChange={handlerChangeData}
                      placeholder="공지사항 내용 작성"
                    ></textarea>
                  </div>
                </div>
              </article>
              <article className="edit-content-container">
                <div className="article-header">
                  <p>
                    <span className="article-header-title">
                      사진 등록(최대 10장)
                    </span>
                  </p>
                  <SolidRedBtn
                    type="button"
                    className="default-btn"
                    onClick={deleteAllPreviewImage}
                  >
                    전체 지우기
                  </SolidRedBtn>
                </div>
                <div className="file-wrap">
                  <FileOneWrap onClick={handleButtonClick}>
                    <img src="/image/icon/camera.svg" alt="camera" />
                    <label>{imageCount}/10</label>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => fileHandleChange(e)}
                      accept=".jpg, .png, .jpeg"
                      style={{ display: "none" }}
                      ref={fileInput}
                      multiple
                    />
                  </FileOneWrap>
                  {imageList.length !== 0 &&
                    imageList.map((image, index) => (
                      <FileOneWrap key={index}>
                        <img
                          src={`${previewImg[index]}`}
                          className="preview-image"
                          alt="preview"
                        />
                        <p style={{ display: "none" }}>{image.name}</p>
                        <div
                          className="delete-preview-image"
                          onClick={() => handleDeleteFile(index)}
                        >
                          <img
                            src="/image/icon/cancel.svg"
                            className="cancel-icon"
                            alt="cancel"
                          />
                        </div>
                      </FileOneWrap>
                    ))}
                </div>
              </article>
              <article className="edit-content-container">
                <div className="article-header">
                  <p>
                    <span className="article-header-title">
                      문서 등록({docCount})
                    </span>
                  </p>
                  <SolidRedBtn
                    type="button"
                    className="default-btn"
                    onClick={deleteAllDoc}
                  >
                    전체 지우기
                  </SolidRedBtn>
                </div>
                <div className="doc-wrap">
                  <DocumentWrap onClick={handleDocButtonClick}>
                    <label>+ 문서 등록하기</label>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => docHandleChange(e)}
                      accept=".pdf, .pptx, .docx, .xlsx"
                      style={{ display: "none" }}
                      ref={docInput}
                      multiple
                    />
                  </DocumentWrap>
                  {docList.length !== 0 &&
                    docList.map((doc: File | any, index) => (
                      <AttachFileWrap key={index}>
                        <div>
                          {/* input[file]을 통해서 file 추가 시 */}
                          {doc.name !== undefined ? (
                            <>
                              <DocIcon
                                className={doc.name.substring(
                                  doc.name.lastIndexOf(".") + 1
                                )}
                              />
                              <p>
                                {doc.name.length > 12
                                  ? `${doc.name.substring(
                                      0,
                                      12
                                    )}...${doc.name.substring(
                                      doc.name.lastIndexOf(".")
                                    )}`
                                  : doc.name}
                              </p>
                            </>
                          ) : (
                            // DB에 저장되어있는 파일보여줄 때
                            <>
                              <DocIcon className={doc.mime_type} />
                              <p>
                                {doc.origin_file_name.length > 12
                                  ? `${doc.origin_file_name.substring(
                                      0,
                                      12
                                    )}...${doc.mime_type}`
                                  : doc.origin_file_name}
                              </p>
                            </>
                          )}
                          <div
                            className="delete-doc"
                            onClick={() => handleDeleteDoc(index)}
                          >
                            <img src="/image/icon/close.svg" alt="close" />
                          </div>
                        </div>
                      </AttachFileWrap>
                    ))}
                </div>
              </article>
            </EditContainer>
          </>
        )}
      </PageArticleWrap>
    </>
  );
}

// 공지사항 작성
export function NoticeWrite() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  function goList() {
    navigate(ListUrl);
  }
  // 전역 데이터
  const { classData } = useContext(UserClassContext);
  // FIXME: user_id 임시로 1로 지정함, 나중에 login 정보로 설정하기
  const [selectDatas, setSelectDatas] = useState<NoticeWriteType>({
    title: "",
    content: "",
    user_id: 1,
    class_ids: [],
    remove_file_id_list: [],
  });

  // 반 영역 선택 시 checkbox show/hide
  const selectClassRef = useRef(null);
  const [isShow, setIsShow] = useState(false);
  function clickSelectClassInput() {
    setIsShow((prev) => !prev);
  }
  const [checkAll, setCheckAll] = useState(true);
  function checkedClassIds({
    currentTarget: { value, checked },
  }: React.ChangeEvent<HTMLInputElement>) {
    let allIds = classData.map((c) => c.id);
    // 전체 선택 체크/해제 시
    if (Number(value) === 0) {
      if (checked) {
        setSelectDatas((prev) => ({ ...prev, class_ids: allIds }));
        setCheckAll(true);
      } else {
        setSelectDatas((prev) => ({ ...prev, class_ids: [] }));
        setCheckAll(false);
      }
    }
    // 전체가 아닌 value를 체크/해제 할 때
    else {
      if (!checked) {
        let ids = selectDatas.class_ids.filter((cId) => Number(value) !== cId);
        setSelectDatas((prev) => ({ ...prev, class_ids: ids }));
        if (selectDatas.class_ids.length === classData.length)
          setCheckAll(false);
      }
      // 체크 시
      else {
        let ids = [...selectDatas.class_ids, Number(value)].sort(
          (a, b) => a - b
        );
        setSelectDatas((prev) => ({ ...prev, class_ids: ids }));
        if (selectDatas.class_ids.length === classData.length - 1)
          setCheckAll(true);
      }
    }
  }
  function handlerChangeData({
    currentTarget: { name, value },
  }: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
    setSelectDatas((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // 파일 관련 시작 -----------------------
  const [docList, setDocList] = useState<File[]>([]); // 문서 파일 자체
  const [imageList, setImageList] = useState<File[]>([]); // 이미지 파일 자체
  const [previewImg, setPreviewImg] = useState<String[]>([]); // 이미지 파일의 url(미리보기 이미지)
  const [docCount, setDocCount] = useState(0);
  const [imageCount, setImageCount] = useState(0);
  const FILEMAXCOUNT = 10;
  const FILEDOCMAXCOUNT = 5;
  const fileInput = useRef<HTMLInputElement>(null);
  const docInput = useRef<HTMLInputElement>(null);
  // 파일 선택 - input 클릭 시(사진)
  const handleButtonClick = (e: any) => {
    fileInput.current?.click();
  };
  // 파일 선택 - input 클릭 시(문서)
  const handleDocButtonClick = (e: any) => {
    if (docInput.current) docInput.current.click();
  };
  // 사진등록 handler
  const fileHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileArr = event.target.files;
    let _fileArr: File[] = [];

    let count = 0; // 등록된 사진 수
    if (fileArr && fileArr.length) {
      // file type 확인
      for (let j = 0; j < fileArr.length; j++) {
        if (fileArr[j].type.includes("image")) _fileArr.push(fileArr[j]);
      }
      count = _fileArr.length > FILEMAXCOUNT ? FILEMAXCOUNT : _fileArr.length;
      setImageList(_fileArr.slice(0, count));
      setImageCount(count);
      // 파일 url
      let fileUrls: string[] = [];
      _fileArr.forEach((file, index) => {
        const fileRead = new FileReader();
        fileRead.onload = (e) => {
          if (e.target && e.target.result) {
            fileUrls[index] = e.target.result.toString();
            setPreviewImg(fileUrls);
          }
        };
        fileRead.onloadend = () => {
          event.target.value = "";
        };
        fileRead.readAsDataURL(file);
      });
    }
  };
  // 미리보기 파일 전체 삭제
  function deleteAllPreviewImage() {
    setImageList([]);
  }
  // 이미지 hover 시 파일삭제(x) 버튼 클릭 - 이미지 삭제(화면상에서만)
  const handleDeleteFile = (imageIndex: number) => {
    setImageList(imageList.filter((img, index) => index !== imageIndex));
    setPreviewImg(previewImg.filter((img, index) => index !== imageIndex));
  };
  // 문서 등록
  const docHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const allowedExtensions = ["pdf", "pptx", "docx", "xlsx"];
    const fileArr = event.target.files;
    let _fileArr: File[] = [];

    let count = 0; // 등록된 문서 수
    if (fileArr && fileArr.length) {
      // file type 확인
      for (let j = 0; j < fileArr.length; j++) {
        const fileName = fileArr[j].name;
        const fileExtension = fileName
          .substring(fileName.lastIndexOf(".") + 1)
          .toLowerCase(); // 파일 이름으로부터 확장자 추출

        if (fileExtension && allowedExtensions.includes(fileExtension))
          _fileArr.push(fileArr[j]);
      }
      count =
        _fileArr.length > FILEDOCMAXCOUNT ? FILEDOCMAXCOUNT : _fileArr.length;
      setDocList(_fileArr.slice(0, count));
      setDocCount(count);
      // 파일 url
      _fileArr.forEach((file, index) => {
        const fileRead = new FileReader();
        fileRead.onloadend = () => {
          event.target.value = "";
        };
        fileRead.readAsDataURL(file);
      });
    }
  };
  // 미리보기 파일 전체 삭제
  function deleteAllDoc() {
    setDocList([]);
  }
  // 파일 hover 시 파일삭제(x) 버튼 클릭 - 파일삭제(화면상에서만)
  const handleDeleteDoc = (docIndex: number) => {
    setDocList(docList.filter((doc, index) => index !== docIndex));
  };
  // 파일 관련 끝 -----------------------
  // 작성 완료 후 등록 시작---------------------
  async function submitNoticeInfo() {
    try {
      if (!selectDatas.title) {
        alert("공지사항 제목을 입력해주세요.");
        return;
      }
      if (!selectDatas.content) {
        alert("공지사항 내용을 입력해주세요.");
        return;
      }
      // 전체 공지일 때 class_ids 빈배열로 보내야함
      if (selectDatas.class_ids.length === classData.length)
        selectDatas.class_ids = [];
      // 이미지/문서 하나로 합치기
      const fileDatas: File[] = [...imageList, ...docList];
      // 다 입력이 됐다면 API 호출
      let goList = false;
      let formData = new FormData();
      // 파일이 있는 경우 FormData로 파일 추가
      const jsonData = JSON.stringify(selectDatas);
      const _jsonData = new Blob([jsonData], { type: "application/json" });
      formData.append("data", _jsonData, "data");
      if (fileDatas.length > 0) {
        fileDatas.forEach((file, index) => {
          formData.append("files", file);
        });
      } else formData.append("files", new Blob([]));
      const result = await postNotice(formData);
      // console.log("등록 result ", result);
      goList = result.code === 200 ? true : false;
      if (result?.message) alert(result?.message);
      if (goList) navigate(`${ListUrl}`);
    } catch (error) {
      console.error("API error ", error);
    }
  }
  // 작성 완료 후 등록 끝---------------------
  // useEffect --------------------
  useEffect(() => {
    let ids = classData.map((c) => c.id);
    setSelectDatas((prev) => ({
      ...prev,
      class_ids: ids,
    }));
    setLoading(true);
  }, [classData]);
  useEffect(() => {
    setImageCount(imageList.length);
  }, [imageList]);
  useEffect(() => {
    setDocCount(docList.length);
  }, [docList]);
  return (
    <>
      <PageHeaderTitleButtonStyle>
        <p className="header-title">공지사항 신규 작성</p>
        {/* <div className="button-wrap">
                      <OutlinePrimaryBtn className="default-btn" onClick={showTempStorageModal}>불러오기</OutlinePrimaryBtn>
                      <OutlinePrimaryBtn className="default-btn">임시저장</OutlinePrimaryBtn>
                  </div> */}
        <div className="button-wrap">
          <SolidPrimaryWhiteBtn className="default-btn" onClick={goList}>
            취소
          </SolidPrimaryWhiteBtn>
          <SolidPrimaryBtn className="default-btn" onClick={submitNoticeInfo}>
            완료
          </SolidPrimaryBtn>
        </div>
      </PageHeaderTitleButtonStyle>
      <PageArticleWrap>
        {!loading ? (
          <Loading />
        ) : (
          <>
            <nav className="filter-container">
              <div className="filter-wrap position-r">
                <label>반</label>
                <input
                  type="text"
                  name="class_ids"
                  onClick={clickSelectClassInput}
                  ref={selectClassRef}
                  value={
                    checkAll
                      ? "전체"
                      : selectDatas.class_ids.map(
                          (selectClassIdx) =>
                            classData.find((c) => selectClassIdx === c.id)
                              ?.name || "전체"
                        )
                  }
                  readOnly
                />
                {isShow && (
                  <CheckBoxWrap className="checkbox-div-wrap">
                    <label htmlFor="checkAll">
                      전체
                      <CustomCheckbox
                        type="checkbox"
                        id="checkAll"
                        name="class_ids"
                        value={0}
                        checked={checkAll}
                        onChange={checkedClassIds}
                      />
                    </label>
                    {classData.map((c) => (
                      <label key={c.id} htmlFor={`class${c.id}`}>
                        {c.name}
                        <CustomCheckbox
                          type="checkbox"
                          id={`class${c.id}`}
                          name="class_ids"
                          value={c.id}
                          checked={
                            selectDatas.class_ids.find(
                              (selectClassIdx) => c.id === selectClassIdx
                            )
                              ? true
                              : false
                          }
                          onChange={checkedClassIds}
                        />
                      </label>
                    ))}
                  </CheckBoxWrap>
                )}
              </div>
            </nav>
            <EditContainer>
              <article className="edit-content-container">
                <div className="article-header">
                  <p>
                    <span className="article-header-title">내용 작성</span>
                  </p>
                </div>
                <div className="article-content">
                  <div>
                    <label htmlFor="title"></label>
                    <input
                      type="text"
                      name="title"
                      id="title"
                      value={selectDatas.title}
                      onChange={handlerChangeData}
                      placeholder="공지사항 제목 입력"
                    />
                  </div>
                  <div>
                    <label htmlFor="content"></label>
                    <textarea
                      name="content"
                      id="content"
                      cols={30}
                      rows={10}
                      value={selectDatas.content}
                      onChange={handlerChangeData}
                      placeholder="공지사항 내용 작성"
                    ></textarea>
                  </div>
                </div>
              </article>
              <article className="edit-content-container">
                <div className="article-header">
                  <p>
                    <span className="article-header-title">
                      사진 등록(최대 10장)
                    </span>
                  </p>
                  <SolidRedBtn
                    type="button"
                    className="default-btn"
                    onClick={deleteAllPreviewImage}
                  >
                    전체 지우기
                  </SolidRedBtn>
                </div>
                <div className="file-wrap">
                  <FileOneWrap onClick={handleButtonClick}>
                    <img src="/image/icon/camera.svg" alt="camera" />
                    <label>{imageCount}/10</label>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => fileHandleChange(e)}
                      accept=".jpg, .png, .jpeg"
                      style={{ display: "none" }}
                      ref={fileInput}
                      multiple
                    />
                  </FileOneWrap>
                  {imageList.length !== 0 &&
                    imageList.map((image, index) => (
                      <FileOneWrap key={index}>
                        <img
                          src={`${previewImg[index]}`}
                          className="preview-image"
                          alt="preview"
                        />
                        <p style={{ display: "none" }}>{image.name}</p>
                        <div
                          className="delete-preview-image"
                          onClick={() => handleDeleteFile(index)}
                        >
                          <img
                            src="/image/icon/cancel.svg"
                            className="cancel-icon"
                            alt="cancel"
                          />
                        </div>
                      </FileOneWrap>
                    ))}
                </div>
              </article>
              <article className="edit-content-container">
                <div className="article-header">
                  <p>
                    <span className="article-header-title">
                      문서 등록({docCount})
                    </span>
                  </p>
                  <SolidRedBtn
                    type="button"
                    className="default-btn"
                    onClick={deleteAllDoc}
                  >
                    전체 지우기
                  </SolidRedBtn>
                </div>
                <div className="doc-wrap">
                  <DocumentWrap onClick={handleDocButtonClick}>
                    <label>+ 문서 등록하기</label>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => docHandleChange(e)}
                      accept=".pdf, .pptx, .docx, .xlsx"
                      style={{ display: "none" }}
                      ref={docInput}
                      multiple
                    />
                  </DocumentWrap>
                  {docList.length !== 0 &&
                    docList.map((doc, index) => (
                      <AttachFileWrap key={index}>
                        <div>
                          <DocIcon
                            className={doc.name.substring(
                              doc.name.lastIndexOf(".") + 1
                            )}
                          />
                          <p>
                            {doc.name.length > 12
                              ? `${doc.name.substring(
                                  0,
                                  12
                                )}...${doc.name.substring(
                                  doc.name.lastIndexOf(".")
                                )}`
                              : doc.name}
                          </p>
                          <div
                            className="delete-doc"
                            onClick={() => handleDeleteDoc(index)}
                          >
                            <img src="/image/icon/close.svg" alt="close" />
                          </div>
                        </div>
                      </AttachFileWrap>
                    ))}
                </div>
              </article>
            </EditContainer>
          </>
        )}
      </PageArticleWrap>
      {/* <TempStorageModalComponent isOpen={isOpen} header={storageHeader} content={tempStorageList} isClose={closeModal} /> */}
    </>
  );
}

export function NoticeList() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  function goToNextPage(page: string) {
    navigate(`${page}`);
  }
  // 전역 데이터
  const { classData, userData, classSelectOption } =
    useContext(UserClassContext);
  // 페이지
  const [totalCount, setTotalCount] = useState(0);
  // 페이지네이션
  const [page, setPage] = useState(1); // 현재 페이지
  const [limit, setLimit] = useState(10); // 보여줄 게시물 개수
  const buttonPerPage = 10; // 보여줄 페이지네이션 버튼 수
  // console.log(totalCount, limit);
  const numPages = Math.ceil(totalCount / limit); // 총 페이지 수
  const [startButtonNum, setStartButtonNum] = useState(1); // 버튼 시작 숫자
  const [endButtonNum, setEndButtonNum] = useState(
    startButtonNum + buttonPerPage - 1
  ); // 버튼 끝 숫자

  // Pagenation에서 버튼 클릭 시 전달받는 값
  function isClickButton(str: string) {
    if (str === "prev") handlePrevPage();
    else handleNextPage();
  }
  // 이전페이지 이동(buttonPerPage만큼 -)
  function handlePrevPage() {
    let prevPer =
      page % 10 === 0
        ? page - buttonPerPage
        : page - buttonPerPage + (buttonPerPage - (page % 10));
    setEndButtonNum(prevPer);
    let startPrevPer = prevPer - buttonPerPage + 1;
    setPage(prevPer);
    setStartButtonNum(startPrevPer < 1 ? 1 : startPrevPer); // 처음페이지 버튼의 숫자가 1보다 작을 경우
  }
  // 다음페이지 이동(buttonPerPage만큼 +)
  function handleNextPage() {
    let nextPer =
      page % 10 === 0
        ? page + 1
        : page + 1 + buttonPerPage - ((page % 10) % buttonPerPage);
    setPage(nextPer);
    setStartButtonNum(nextPer);
    let endNextPer = nextPer + buttonPerPage - 1;
    setEndButtonNum(endNextPer > numPages ? numPages : endNextPer); // 마지막페이지 버튼이 총 페이지보다 클 경우
  }
  // 수정하기
  function goNoticeEdit(noticeIdx: number) {
    let noticeOne = noticeList.find((n) => n.id === noticeIdx);
    navigate(`${noticeIdx}`, { state: noticeOne });
  }

  // 알림장 List 관련
  const [noticeList, setNoticeList] = useState<NoticeInfo[]>([]);
  // const [startDate, setStartDate] = useState<Date>(new Date());
  // 필터 검색 시
  const [searchData, setSearchData] = useState<{
    class_id: number;
    title: string;
  }>({
    class_id: 0,
    title: "",
  });
  // 필터 검색 - 반 선택
  function handleChangeOption(prop: number) {
    setSearchData((prev) => ({ ...prev, class_id: prop }));
  }
  // 필터 검색 - input change
  function handleChangeSearchText(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setSearchData((prev) => ({ ...prev, [name]: value }));
  }
  // 필터 검색 - title 검색
  function handleClickSearchNotice() {
    if (searchData.class_id === 0 && searchData.title === "")
      getNoticeDataAPI();
    else getNoticeDataAPI(searchData);
  }

  // 알림장 가져오기
  async function getNoticeDataAPI(searchDate?: {
    class_id: number;
    title: string;
  }) {
    setLoading(false);
    const result = await getNotice(searchDate);
    if (result.code === 200) {
      let newData = result.data.filter(
        (d: NoticeInfo, idx: number, callback: NoticeInfo[]) =>
          idx === callback.findIndex((d1) => d1.id === d.id)
      );
      setTotalCount(newData.length);
      setNoticeList(newData);
    } else {
      setNoticeList([]);
      alert(result.message);
    }
    setLoading(true);
    setIsRefresh(false);
  }
  // 모달 - 상세보기 관련 시작 -----------------------
  const headerText = "공지사항 상세내용";
  const [noticeOneData, setNoticeOneData] = useState<NoticeInfo>(Object);
  const [isOpen, setIsOpen] = useState(false);
  // 임시보관함 모달 보여주기
  const showNoticeOneDetailInModal = (noticeIdx: number) => {
    setNoticeOneData(
      noticeList.find((notice) => notice.id === noticeIdx) || Object
    );
    // Modal창 open 및 내용 전달
    setIsOpen(true);
  };
  // 모달창 닫았는지 확인
  function closeModal(prop: boolean) {
    setIsOpen(prop);
  }
  // 상세보기 관련 끝 -----------------------
  // 모달에서 공지사항 삭제 성공 시 목록 새로고침
  const [isRefresh, setIsRefresh] = useState(false);
  function refreshData(prop: boolean) {
    setIsRefresh(prop);
  }
  useEffect(() => {
    if (isRefresh) getNoticeDataAPI();
  }, [isRefresh]);
  useEffect(() => {
    getNoticeDataAPI();
  }, []);
  return (
    <>
      <PageHeaderTitleButtonStyle>
        <p className="header-title">공지사항</p>
        <div className="button-wrap">
          {/* <OutlinePrimaryBtn className="default-btn">불러오기</OutlinePrimaryBtn> */}
          <SolidPrimaryBtn
            className="default-btn"
            onClick={() => goToNextPage("write")}
          >
            신규작성
          </SolidPrimaryBtn>
        </div>
      </PageHeaderTitleButtonStyle>
      <PageArticleWrap>
        <nav className="filter-container">
          <div className="filter-wrap">
            <label>반</label>
            <SelectOption
              optionData={classSelectOption}
              onChange={(prop: number) => handleChangeOption(prop)}
            />
          </div>
          <div className="filter-wrap">
            <label>검색</label>
            <input
              type="text"
              name="title"
              value={searchData.title}
              onChange={(event) => handleChangeSearchText(event)}
              placeholder="검색할 공지사항을 입력해주세요."
            />
          </div>
          {/* <CustomDatePickerWrap className="custom-date-picker">
              <label>날짜</label>
              <ReactDatePicker
                  enableTabLoop={false}
                  dateFormat='yyyy-MM-dd (E)' // 날짜형태
                  formatWeekDay={(day) => day.substring(0, 1)}
                  shouldCloseOnSelect // 날짜 선택 시 datepicker 자동 닫힘
                  todayButton="오늘"
                  selected={startDate}
                  onChange={(date) => setStartDate(date || new Date())}
                  dropdownMode="select"
                  minDate={new Date('2010-01-01')}
                  maxDate={new Date(new Date().getFullYear(), new Date().getMonth()+2, 0)}
                  dayClassName={(d) => d.getDate() === startDate?.getDate() ? 'selectedDay' : 'unSelectedDay'}
                  renderCustomHeader={({
                      date,
                      changeMonth,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                  }) => (
                      <div className="custom-header-container">
                          <div>
                              <button
                                  type='button'
                                  onClick={decreaseMonth}
                                  className="custom-month-button"
                                  disabled={prevMonthButtonDisabled}
                              >
                                  <img src="/image/icon/arrow_left.svg" alt="left"/>
                              </button>
                              <span className="custom-year">{getYear(date)}</span>
                              <select
                                  value={months[getMonth(date)]}
                                  className="custom-month"
                                  onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
                              >
                              {months.map((option) => (
                                  <option key={option} value={option}>
                                      {option}
                                  </option>
                              ))}
                              </select>
                              <button
                                  type='button'
                                  onClick={increaseMonth}
                                  className="custom-month-button"
                                  disabled={nextMonthButtonDisabled}
                              >
                                  <img src="/image/icon/arrow_right.svg" alt="right"/>
                              </button>
                          </div>
                      </div>
                  )}
              />
          </CustomDatePickerWrap> */}
          <SolidPrimarySubBtn
            className="default-btn"
            onClick={handleClickSearchNotice}
          >
            조회
          </SolidPrimarySubBtn>
        </nav>
        <article className="list-content-container">
          <div className="article-header">
            <p>
              <span className="article-header-title">
                공지사항 목록({totalCount})
              </span>
            </p>
          </div>
          {!loading ? (
            <Loading />
          ) : (
            <ListContentWrap>
              <div className="list-one-wrap">
                {totalCount === 0 ? (
                  <NoDataWithImageTextButton
                    text={NODATATEXTNOTICE}
                    btnText="신규 공지사항 등록"
                    linkUrl="/notice/write"
                  />
                ) : (
                  <div className="list-table">
                    <nav className="list-table-header">
                      <div className="w-8">No.</div>
                      <div className="w-12">작성일자</div>
                      <div className="w-10">작성자</div>
                      <div className="w-20">공지반</div>
                      <div className="w-30">제목</div>
                      <div className="w-10">-</div>
                    </nav>
                    {noticeList.map((notice, index) => (
                      <NoticeOne
                        key={index}
                        onClick={() => showNoticeOneDetailInModal(notice.id)}
                      >
                        <div className="w-8">
                          <p>{index + 1}</p>
                        </div>
                        <div className="w-12">
                          <p>{formattedDateHyphenYYYYMMDD(notice.reg_date)}</p>
                        </div>
                        <div className="w-10">
                          {(() => {
                            let user = userData.find(
                              (user) => user.id === notice.user_id
                            );
                            return (
                              <p>{user ? aesCBCDecrypt(user.name) : ""}</p>
                            );
                          })()}
                        </div>
                        <div className="w-20">
                          <p>
                            {notice.class_list.length === 0 ||
                            classData.length === notice.class_list.length ? (
                              "전체"
                            ) : (
                              <span>
                                {notice.class_list.map((c, index) =>
                                  index === 0 ? `${c.name}` : `/${c.name}`
                                )}
                              </span>
                            )}
                          </p>
                        </div>
                        <div className="w-30">
                          <p>{notice.title}</p>
                        </div>
                        <div className="w-10">
                          <OutlinePrimaryBtn
                            type="button"
                            className="default-btn"
                            onClick={() => goNoticeEdit(notice.id)}
                          >
                            수정하기
                          </OutlinePrimaryBtn>
                        </div>
                      </NoticeOne>
                    ))}
                  </div>
                )}
              </div>
            </ListContentWrap>
          )}
          {totalCount !== 0 && (
            <Pagenation
              totalCount={totalCount}
              total={numPages}
              limit={limit}
              page={page}
              setPage={setPage}
              startButtonNum={startButtonNum}
              setClickButton={isClickButton}
            />
          )}
        </article>
      </PageArticleWrap>
      <CommonModalComponent
        type="noticeDetail"
        isOpen={isOpen}
        header={headerText}
        content={noticeOneData}
        isRefresh={refreshData}
        isClose={closeModal}
      />
    </>
  );
}
export const UserClassContext = createContext<{
  classData: ClassInfo[];
  userData: UserInfo[];
  classSelectOption: provinceInfo[];
}>({ classData: [], userData: [], classSelectOption: [] });
export function Notice() {
  const location = useLocation();
  const pathName = location.pathname;
  ListUrl = pathName.substring(0, pathName.lastIndexOf("/"));

  const [userAllList, setUserAllList] = useState<UserInfo[]>([]);
  const [classAllList, setClassAllList] = useState<ClassInfo[]>([]);
  // select-option용
  const [classList, setClassList] = useState<provinceInfo[]>([
    { label: "전체", value: 0 },
  ]);

  useEffect(() => {
    async function getUserAndClass() {
      // 공지사항 내 user_id와 class_id랑 대조하기 위한 user/반 전체 리스트
      const userResult = await getUser();
      const classResult = await getClass();
      if (userResult.code === 200) setUserAllList(userResult.data);
      else setUserAllList([]);
      if (classResult.code === 200) setClassAllList(classResult.data);
      else setClassAllList([]);

      let classArray: any[] = [{ label: "전체", value: 0 }];
      classResult.data.forEach((d: ClassInfo) => {
        let option = { label: d.name, value: d.id };
        classArray.push(option);
      });
      setClassList(classArray);
    }
    getUserAndClass();
  }, []);
  return (
    <UserClassContext.Provider
      value={{
        classData: classAllList,
        userData: userAllList,
        classSelectOption: classList,
      }}
    >
      <Outlet />
    </UserClassContext.Provider>
  );
}
